import styled from 'styled-components';
import {tokens} from '@tickchak/react-share/app';
import {dFlex, dFlexColumn, dFlexBetween, flexRowReverse, alignCenter, dFlexStart} from '../../../../../../../globalVariables/GlobalFlex';

export {dot} from '../../timetableSales.css';

export const summaryColumn = styled.div`
  ${dFlexColumn}
  direction: rtl;
  gap: var(--space-md);
`;
export const mCard = styled.div`
  ${dFlexColumn}
  gap: var(--space-sm);
  padding: var(--space-lg);
  background: var(--TA-color-bg-base);
  border: 1px solid var(--TA-color-border-subtle);
  border-radius: var(--radius-xl);
`;
export const mTitle = styled.div`
  font-size: 18px;
  line-height: 23px;
`;
export const mTotalRow = styled.div`
  ${dFlexStart}
  gap: var(--space-sm);
`;
export const mTotal = styled.div`
  font-size: ${tokens.typography.fontSize.body};
`;
export const mBig = styled.div`
  font-size: ${tokens.typography.fontSize.headingSub};
  font-weight: ${tokens.typography.fontWeight.bold};
  line-height: 23px;
`;
export const mRows = styled.div`
  ${dFlexColumn}
  gap: var(--space-sm);
`;
export const mRow = styled.div`
  ${dFlexBetween}
  direction: rtl;
  gap: var(--space-sm);
  font-size: ${tokens.typography.fontSize.caption};
`;
export const mLabel = styled.div`
  ${dFlex}
  ${flexRowReverse}
  ${alignCenter}
  gap: var(--space-sm);
`;
export const mBar = styled.div`
  direction: rtl;
  height: 8px;
  border-radius: var(--radius-full);
  background: var(--TA-color-bg-surface-hover);
  overflow: hidden;
`;
export const mBarFill = styled.div`
  height: 8px;
  border-radius: var(--radius-full);
  background: var(--TA-color-state-info-main);
`;
